import { Box, Container, Stack, Typography } from "@mui/material";
import { BackButton, BackDropLoading, Loading } from "@/organism";
import useDetail from "./useDetail";
import SuperChatContent from "@/templates/SuperChatContent";
import { useParams } from "react-router-dom";
import { FloatingAiChat } from "@/organism/FloatingAiChat";

/**
 * QNA 컨텐츠 상세 페이지
 *
 * @description QNA 컨텐츠의 상세 정보를 조회하고 수정/삭제할 수 있는 페이지
 * @author Max <sud665@ymjlab.com>
 * @version 1.0.0
 * @since 2025-01-16
 */
export const Detail = () => {
  const { id } = useParams<{ id: string }>();
  const { content, isLoading, handleContentUpdate, handleDelete } = useDetail(
    id ? parseInt(id) : 0
  );

  if (!content) {
    return <Loading />;
  }

  return (
    <Container maxWidth="xl">
      <BackDropLoading isLoading={isLoading} />
      <Box
        display="flex"
        justifyContent="space-between"
        gap={2}
        alignItems="end"
        mb={2}
      >
        <Stack direction="column" gap={1}>
          <BackButton to="/chat/content">QNA 컨텐츠 목록</BackButton>
          <Typography
            component="h1"
            variant="h5"
            fontWeight="bold"
            gutterBottom
          >
            QNA 컨텐츠 상세 정보
          </Typography>
        </Stack>
      </Box>
      <SuperChatContent.EditForm
        contentInfo={content}
        onEdit={handleContentUpdate}
        onDelete={handleDelete}
      />

      {/* 🔥 Floating AI Chat 컴포넌트 */}
      <FloatingAiChat />
    </Container>
  );
};
